<app-job-header></app-job-header>
<div class="hero-container">
    <div class="jobs-section">
        <!-- Hero Section -->
        <div class="search-section">
            <h1>Find your <span class="highlight-text">new teaching journey</span> today</h1>
            <p style="font-size: 12px; margin-top: 8px;">Search and apply from thousands of jobs from the best schools
                across India</p>

            <div class="search-bar">


                <mat-form-field class="search-input" appearance="outline">
                    <mat-label>Search</mat-label>
                    <mat-icon matPrefix color="primary">search</mat-icon>
                    <input matInput placeholder="What position are you looking for?" [(ngModel)]="filters.position" />
                    <!-- <mat-icon matSuffix>search</mat-icon> -->
                    <!-- <mat-hint>Hint</mat-hint> -->
                </mat-form-field>

                <mat-form-field class="search-input" appearance="outline">
                    <mat-label>Location</mat-label>
                    <mat-icon matPrefix color="primary">place</mat-icon>
                    <input matInput placeholder="Location" [(ngModel)]="filters.location" />
                </mat-form-field>

                <button mat-raised-button color="primary" class="search-button" (click)="searchJobs()">
                    Search Jobs
                </button>
            </div>
            <!-- Additional Filters -->
            <div class="additional-filters">
                <mat-form-field appearance="outline">
                    <mat-label>Board wise</mat-label>
                    <mat-icon matPrefix color="primary"></mat-icon>
                    <mat-select [(ngModel)]="filters.board">
                        <mat-option *ngFor="let board of boards" [value]="board">{{ board }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Medium wise</mat-label>
                    <mat-icon matPrefix color="primary"></mat-icon>
                    <mat-select [(ngModel)]="filters.medium">
                        <mat-option *ngFor="let medium of mediums" [value]="medium">{{ medium }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Level wise</mat-label>
                    <mat-icon matPrefix color="primary"></mat-icon>
                    <mat-select [(ngModel)]="filters.level">
                        <mat-option *ngFor="let level of levels" [value]="level">{{ level }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Subject wise</mat-label>
                    <mat-icon matPrefix color="primary"></mat-icon>
                    <mat-select [(ngModel)]="filters.subject">
                        <mat-option *ngFor="let subject of subjects" [value]="subject">{{ subject }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>Position wise</mat-label>
                    <mat-icon matPrefix color="primary"></mat-icon>
                    <mat-select [(ngModel)]="filters.position">
                        <mat-option *ngFor="let position of positions" [value]="position">{{ position
                            }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

    </div>
</div>
<!-- Main Content Wrapper -->
<div class="main-container">
    <!-- Sidebar Section for Filters -->
    <div class="filters-sidebar">
        <h3>
            Filters
            <mat-icon style="vertical-align: middle; position:absolute; left: 248px;">filter_list</mat-icon>
        </h3>

        <!-- Location Filter -->
        <h4>Location</h4>
        <mat-radio-group [(ngModel)]="filters.locationRange" color="accent">
            <mat-radio-button *ngFor="let location of locations" [value]="location">{{ location
                }}</mat-radio-button>
        </mat-radio-group>

        <!-- Salary Filters -->
        <h4>Salary range</h4>
        <mat-radio-group [(ngModel)]="filters.salaryRange">
            <mat-radio-button value="all-time">> ₹5,000</mat-radio-button>
            <mat-radio-button value="last-24-hours">> ₹10,000</mat-radio-button>
            <mat-radio-button value="last-3-days">> ₹15,000</mat-radio-button>
            <mat-radio-button value="last-7-days">> ₹20,000</mat-radio-button>
            <mat-radio-button value="last-7-days">> ₹30,000</mat-radio-button>
        </mat-radio-group>


        <!-- Date Filters -->
        <h4>Date of posting</h4>
        <mat-radio-group [(ngModel)]="filters.datePosted">
            <mat-radio-button value="all-time">All time</mat-radio-button>
            <mat-radio-button value="last-24-hours">Last 24 hours</mat-radio-button>
            <mat-radio-button value="last-3-days">Last 3 days</mat-radio-button>
            <mat-radio-button value="last-7-days">Last 7 days</mat-radio-button>
        </mat-radio-group>

        <!-- experience Filters -->
        <h4>Work experience</h4>
        <mat-radio-group [(ngModel)]="filters.experience">
            <mat-radio-button value="any">Any experience</mat-radio-button>
            <mat-radio-button value="freshers">Freshers</mat-radio-button>
            <mat-radio-button value="internship">Internship</mat-radio-button>
        </mat-radio-group>


        <!-- employment Filters -->
        <h4>Type of employment</h4>
        <mat-checkbox [(ngModel)]="filters.employmentType.fullTime">Full-time</mat-checkbox>
        <mat-checkbox [(ngModel)]="filters.employmentType.partTime">Part-time</mat-checkbox>
        <mat-checkbox [(ngModel)]="filters.employmentType.internship">Internships</mat-checkbox>
    </div>

    <!-- Main Section for Jobs -->
    <div class="jobs-section">

        <!-- Job Listings -->
        <div class="job-listing-section">
            <h2>{{ totalJobs }} Jobs in {{ location }}</h2>
            <button mat-button href="#" class="clear-search">Clear search</button>

            <div class="job-list">
                <div class="wa-container">
                    <div class="whatsapp-section">
                        <div class="whatsapp-card">
                            <div class="whatsapp-icon">
                                <img src="../../assets/images/whatsappicon.svg" alt="WhatsApp Icon">
                            </div>
                            <div class="whatsapp-text">
                                <h3>Stay connected and informed!</h3>
                                <p>Join our WhatsApp community for exclusive updates, promotions, and more</p>
                            </div>
                            <a href="https://chat.whatsapp.com/EDdRZIoKcBZ3MGMCe9mCid" target="_blank" mat-raised-button
                                color="primary" class="join-now-button">Join Now</a>
                        </div>
                    </div>
                </div>
                <div *ngFor="let job of jobs" class="job-item">
                    <img src="{{ job.schoolLogo }}" alt="{{ job.school }}" class="school-logo" />
                    <div class="job-details">
                        <h4>{{ job.title }}</h4>
                        <p>{{ job.location }} · {{ job.type }} · {{ job.salary }}</p>
                        <span class="days-ago">{{ job.daysAgo }} days ago</span>
                    </div>
                    <button mat-raised-button color="accent" (click)="applyForJob(job.id)">Apply Now</button>
                </div>
            </div>

            <!-- Pagination -->
            <mat-paginator [length]="totalJobs" [pageSize]="10" aria-label="Select page"></mat-paginator>
        </div>
    </div>

    <!-- Right Sidebar: Resume Upload Section -->
    <div class="resume-upload-section">
        <h4>🚀 Get noticed faster</h4>
        <p>Upload your resume to make job applications easier and quicker.</p>
        <button mat-raised-button color="primary">Upload your resume</button>
    </div>
</div>
<app-job-footer></app-job-footer>